export function getDotColor(isActive?: boolean | null) {
  if (isActive) return 'var(--color-green-700)';
  return 'var(--color-slate-300)';
}
